module.exports = __webpack_public_path__ + "static/media/chat-person.162f24a8.svg";